import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../../../../utils/constants';
import { usePathname } from 'next/navigation';
const Submit = ({ counter2, formData, setFormData }) => {

  // const [isAgreed, setIsAgreed] = useState(false);
  const path=usePathname();
  const isRoute = path.startsWith("/study-mbbs-abroad");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);

  }, []);

  console.log(isVisible)

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    // Reset dependent dropdown if qualification changes
    if (id === 'educationalQualification') {
      setFormData((prev) => ({
        ...prev,
        [id]: value,
        testTaken: '', // Reset education
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };
  const educationOptions = {
    Pharmacy: ['B.Pharma', 'Pharm.D', 'D.Pharm'],
    Dentistry: ['BDS'],
    Secondary:['None'],
    SeniorSecondary:['None'],
    Diploma:['None'],
    Physiotherapy: ['BPT'],
    Nursing: ['B.Sc Nursing', 'JNM'],
    "Laboratory Technologist": ['B.Sc MLT', 'DMLT'],
    Medicine: ['MBBS'],
    Optometry: ['B.Optom'],
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log({ formData })
    counter2();
    // if (!isAgreed) {
    //   alert('Please agree to the terms and conditions before submitting.');
    //   return;
    // }
    
    
    
    try {
      
      const response = await axios.post(`${BACKEND_URL}/lsq/create-lead`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.status === 201 || response.status === 200) {
        counter2();
        setFormData([]);
      } else {
        console.error('Failed to submit the form.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while submitting the form.');
    }
  };

  return (
    <>
      <div
      className=" flex flex-col rounded-lg p-6  mdb:py-4    mdb:w-[35vw] border-2 border-black-500 z-10 relative bg-gray-50"
      style={{ boxShadow: "10px 10px 0px rgba(0, 0, 0, 1)" }}
    >
      <h2 className="  md:text-center text-[20px] sm:text-base xl:whitespace-nowrap xl:text-[20px]  mdb:text-lg 2xl:text-[22px] mb-6 text-black font-semibold font-poppins">
      Get Started on Your Journey to Study Abroad
      </h2>
        <p className="border-2 max-w-max border-dashed border-blue-400 p-1 font-bold rounded-lg text-sm bg-gradient-to-r from-blue-500 to-teal-500 mb-6 text-transparent bg-clip-text font-poppins">
          Apply now for 2025  intake
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mt-4">
            <label htmlFor="qualification" className="block text-sm font-medium text-black">
              Qualification
            </label>
            <select
              id="educationalQualification"
              value={formData.educationalQualification}
              onChange={handleInputChange}
              required
              className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#F9FAFB]"
            >
              <option value="">Select Qualification</option>
              {Object.keys(educationOptions).map((qualification) => (
                <option key={qualification} value={qualification}>
                  {qualification}
                </option>
              ))}
            </select>
          </div>
          <div className="mt-4">
            <label htmlFor="testTaken" className="block text-sm font-medium text-black">
              Course
            </label>
            <select
              id="testTaken"
              value={formData.testTaken}
              onChange={handleInputChange}
              disabled={!formData.educationalQualification}
              required
              className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#F9FAFB]"
            >
              <option value="">Select Education</option>
              {educationOptions[formData.educationalQualification]?.map((education) => (
                <option key={education} value={education}>
                  {education}
                </option>
              ))}
            </select>
          </div>
          <div className="mt-4">
            <label htmlFor="country" className="block text-sm font-medium text-black">
              Destination
            </label>
            <select
              id="Country"
              value={formData.Country}
              onChange={handleInputChange}
              required
              className="w-full border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#F9FAFB]"
            >
              <option value="">Select Country</option>
              <option value="Australia">Australia</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Ireland">Ireland</option>
              <option value="Canada">Canada</option>
              <option value="UK">UK</option>
              <option value="US">US</option>
            </select>
          </div>
          {/* <div className="mt-4 flex items-center">
            <input
              type="checkbox"
              id="agreement"
              checked={isAgreed}
              required
              onChange={() => setIsAgreed((prev) => !prev)}
              className="mr-2"
            />
            <label htmlFor="agreement" className="text-sm text-gray-500">
              By submitting the form you agree with the terms and conditions, privacy policy
            </label>
          </div> */}
          {/* ${!isAgreed ? 'opacity-50 cursor-not-allowed' : ''} */}
          <button
            type="submit"
             id="submit-leadgen"
             className={`mt-6 w-full bg-gradient-to-r from-blue-500 to-teal-500 text-white font-medium py-2 rounded hover:opacity-90 ${isRoute? 'submit-btn-special' : 'submit-btn-default'}`}
          >
            Submit
          </button>
        </form>
      </div>
    </>
  );
};

export default Submit;